import { cn } from "@/lib/utils";
import Image from "next/image";
import React from "react";

interface LogoTextProps {
  className?: string;
  /** Force a specific scheme regardless of current theme. 'dark' renders the white logo variant. */
  forceScheme?: "light" | "dark";
  /** Optional alt text override */
  alt?: string;
}

const LogoText = ({ className, forceScheme, alt }: LogoTextProps) => {
  const baseAlt = alt || "The Plaster Shop";

  if (forceScheme) {
    const src =
      forceScheme === "dark"
        ? "/images/logo-long-dark.png"
        : "/images/logo-long.png";
    return (
      <Image
        alt={baseAlt}
        src={src}
        fill
        priority
        className={cn("object-contain", className)}
      />
    );
  }

  return (
    <>
      <Image
        alt={baseAlt}
        src="/images/logo-long.png"
        fill
        priority
        className={cn("object-contain dark:hidden", className)}
      />
      <Image
        alt={baseAlt}
        src="/images/logo-long-dark.png"
        fill
        priority
        className={cn("object-contain hidden dark:block", className)}
      />
    </>
  );
};

export default LogoText;
